"use strict";var s=require("./TermsAndConditions/TermsAndConditionsModal.js");exports.TermsAndConditionsModal=s.default;
